var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M7.54 6.29L1.88.64A1 1 0 10.46 2.05l4.95 5L.46 12a1 1 0 000 1.41 1 1 0 00.71.3.999.999 0 00.71-.3l5.66-5.65a1 1 0 000-1.47z"}})}
var staticRenderFns = []

export { render, staticRenderFns }